import script from "./AppLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLoading.vue?vue&type=script&lang=ts&setup=true"

import "./AppLoading.vue?vue&type=style&index=0&id=2d3ad260&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3ad260"]])

export default __exports__